import { inject, Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { Store } from '@ngrx/store';
import { of } from 'rxjs';
import { catchError, filter, map, switchMap, tap, withLatestFrom } from 'rxjs/operators';
import { ReferenceService } from '../../generated/auth/services/reference.service';
import {
  loadOccupation,
  loadOccupationFailure,
  loadOccupationSuccess,
  toggleOccupationLoading,
} from './occupation.actions';
import { selectOccupationList, selectOccupationLoading } from './occupation.selectors';

@Injectable()
export class OccupationEffects {
  private actions$ = inject(Actions);
  private referenceService = inject(ReferenceService);
  private store = inject(Store);

  constructor() {}

  loadOccupation$ = createEffect(() =>
    this.actions$.pipe(
      ofType(loadOccupation),
      withLatestFrom(
        this.store.select(selectOccupationLoading),
        this.store.select(selectOccupationList),
      ),
      filter(([action, isLoading, list]) => !isLoading && (!list || list.length === 0)),
      tap(() => this.store.dispatch(toggleOccupationLoading({ isLoading: true }))),
      switchMap(() =>
        this.referenceService.referenceLookupGetOccupationGet().pipe(
          map((response) => loadOccupationSuccess({ occupation: response.result || [] })),
          catchError((error) => of(loadOccupationFailure({ error }))),
        ),
      ),
    ),
  );
}
